import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import {
  ButtonModule,
  CollapseModule,
  IconModule,
  ModalModule,
  ToggleModule,
} from '@vinnova/ui';
import { AlertInfoComponent } from './components/alert-info/alert-info.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import { EnglishDisclaimerComponent } from './components/english-disclaimer/english-disclaimer.component';
import { EnvironmentBannerComponent } from './components/environment-banner/environment-banner.component';
import { ErrorComponent } from './components/error/error.component';
import { LoginClosedComponent } from './components/login-closed/login-closed.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { NotificationInfoComponent } from './components/notification-info/notification-info.component';
import { SiteFooterComponent } from './components/site-footer/site-footer.component';
import { SiteHeaderComponent } from './components/site-header/site-header.component';
import { SkipToContentComponent } from './components/skip-to-content/skip-to-content.component';
import { environment } from './environment';

@NgModule({
  declarations: [
    EnvironmentBannerComponent,
    SiteHeaderComponent,
    SiteFooterComponent,

    LoginClosedComponent,
    EnglishDisclaimerComponent,
    SkipToContentComponent,
    AlertInfoComponent,
    ErrorComponent,
    NotFoundComponent,
    NotificationInfoComponent,
    CookieBannerComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    IconModule,
    ButtonModule,
    CollapseModule,
    ModalModule,
    ToggleModule,
  ],
  exports: [
    EnvironmentBannerComponent,
    SiteHeaderComponent,
    SiteFooterComponent,

    LoginClosedComponent,
    EnglishDisclaimerComponent,
    SkipToContentComponent,
    AlertInfoComponent,
    NotificationInfoComponent,
    CookieBannerComponent,
  ],
})
export class ETjansterModule {
  public static forRoot(env): ModuleWithProviders<ETjansterModule> {
    return {
      ngModule: ETjansterModule,
      providers: [{ provide: environment, useValue: env }],
    };
  }
}
